// extracted by mini-css-extract-plugin
export default {"errorStyle":"noResultFound_errorStyle__oKu-N","infoStyle":"noResultFound_infoStyle__Y4DOf"};